import type React from "react";

export const TennisBallIcon: React.FC<React.SVGProps<SVGSVGElement>> = (
  props,
) => {
  const { width = 50, height = 50, color = "#6a33ff", ...restProps } = props;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      width={width}
      height={height}
      viewBox="0 0 40.933 40.933"
      {...restProps}
    >
      <title>Tennis Ball Icon</title>
      <g>
        <path
          d="M18.546.079A20.402 20.402 0 0 0 5.984 5.988 20.37 20.37 0 0 0 .076 18.553c5.028.583 10.374 3.153 14.763 7.542 4.391 4.39 6.964 9.74 7.542 14.764a20.39 20.39 0 0 0 12.567-5.905 20.358 20.358 0 0 0 5.903-12.565c-5.016-.582-10.371-3.152-14.76-7.542-4.386-4.389-6.959-9.74-7.545-14.768z"
          fill={color}
        />
        <path
          d="M40.933 19.85a20.41 20.41 0 0 0-5.979-13.866C31.114 2.141 26.12.156 21.085 0c.566 4.397 2.901 9.122 6.815 13.037 3.914 3.915 8.633 6.246 13.033 6.813zM.001 21.09a20.386 20.386 0 0 0 5.983 13.863 20.376 20.376 0 0 0 13.861 5.98c-.566-4.391-2.898-9.113-6.814-13.028C9.119 23.992 4.395 21.66.001 21.09z"
          fill={color}
        />
      </g>
    </svg>
  );
};
